<template>
    <div class="newUpdate">
        <div class="new_update_title">ES6购车核心知识更新</div> 
        <div class="new_update_issue">
            <div class="new_update_issue_title">常见问题({{newUpdateIssue.length}})</div>
            <div class="new_update_item" :class="{isExpired:item.isExpired}" v-for='(item,index) in newUpdateIssue' :key="index" @click="clickItem(item)">
               <div >
                    {{item.name}}
                     <span class="isExpired_show" v-if="item.isExpired">已过期</span>
               </div>
            </div>
        </div>
        <div class='new_update_space'></div>
        <div class="new_update_issue">
                <div class="new_update_issue_title">知识点({{newUpdateKnowledge.length}})</div>
                <div class="new_update_item" :class="{isExpired:item.isExpired}" v-for='(item,index) in newUpdateKnowledge' :key="index" @click="clickItem(item)">
                <div >
                        {{item.name}}
                        <span class="isExpired_show" v-if="item.isExpired">已过期</span>
                </div>
                </div>
        </div>
    </div>
</template>
<script>
export default {
   data(){
       return {
            newUpdateIssue:[
                {isExpired:false,name:'如何邀请好友购买es6'},
                {isExpired:true,name:'ES6线下邀约最后截止时间?ES6线下邀约最后截止时间?ES6线下邀约最后截止时间?ES6线下邀约最后截止时间?ES6线下邀约最后截止时间?'},
                {isExpired:false,name:'ES6线下邀约最后截止时间？'},
                {isExpired:true,name:'ES6线下邀约最后截？'},
            ],
            newUpdateKnowledge:[
                {isExpired:false,name:'ES6购车指南'},
                {isExpired:true,name:'ES8新能源购车补贴指南?ES6线下邀约最后截止时间?ES6线下邀约最后截止时间?ES6线下邀约最后截止时间?ES6线下邀约最后截止时间?ES6线下邀约最后截止时间?'}
            ]
       }
   },
   mounted(){
       console.log("newUpdate===========");
       console.log(this.$route);
       console.log(this.$route.params);
       console.log(this.$route.params.uuid.split('&')[0]);
   },
   methods:{
       clickItem(data){
           console.log("data=======详情================");
           console.log(data);
       }
   }
}
</script>
<style lang='scss' scope>
.newUpdate{
    font-size: j(30);
    padding-bottom:j(50);
    .new_update_title{
        height:j(140);
        line-height: j(140);
        padding:0 j(50);
        font-size:j(50);
        font-weight: bold;
        color:#363C54;
    }
    .new_update_issue_title{
        font-size:j(45);
        color:#363C54;
        padding:j(30) 0;
        border-bottom:1px solid #F0F1F2;
    }
    .new_update_item{
        width:100%;
        padding:j(30) 0;
        font-size: j(30);
        border-bottom:1px solid #F0F1F2;

       display: flex;
       align-items: center;

    .isExpired_show{
        width:j(100);
        height:j(50);
        line-height: j(50);
        font-size: j(24);
        border-radius: 25px;
        background:#F7F7F8;
        text-align: center;
        display: inline-block;
    }
        
    }
    .isExpired{
        color:#9B9DA9;
    }
    
    .new_update_issue{
       padding:0 j(50);
    }
    .new_update_space{
        height:j(20);
        background:#F7F7F8;
    }
    .new_update_knowlegdge{
        background:#fff;
        margin:j(20) 0;
    }

}
</style>





// WEBPACK FOOTER //
// src/views/newUpdate.vue